import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
const { FiAlignLeft, FiArrowDown, FiArrowUp } = FiIcons;

export default function SettingsPanel({ text, onTextChange, position, onPositionChange, logoStyle, onLogoStyleChange, modernAvailable }) {
  return (
    <section className="panel">
      <div className="section-heading">
        <div className="section-icon"><SafeIcon icon={FiAlignLeft} /></div>
        <div><span className="eyebrow">PASUL 03</span><h2>Personalizează banda</h2></div>
      </div>
      <label className="field-label" htmlFor="sponsor-text">Textul de deasupra sponsorilor</label>
      <input id="sponsor-text" className="text-input" value={text} maxLength={110} onChange={event => onTextChange(event.target.value)} placeholder="Echipa Progresul Baia Mare este susținută de" />
      <span className="field-note">Textul și poziția se salvează automat în acest browser.</span>
      <span className="field-label position-label">Poziția benzii</span>
      <div className="position-options">
        <button type="button" className={`position-button ${position === 'bottom' ? 'selected' : ''}`} onClick={() => onPositionChange('bottom')}><SafeIcon icon={FiArrowDown} /> Jos <span>Recomandat</span></button>
        <button type="button" className={`position-button ${position === 'top' ? 'selected' : ''}`} onClick={() => onPositionChange('top')}><SafeIcon icon={FiArrowUp} /> Sus</button>
      </div>
      <span className="field-label position-label">Stil logo-uri</span>
      <div className="position-options">
        <button type="button" className={`position-button ${logoStyle === 'classic' ? 'selected' : ''}`} onClick={() => onLogoStyleChange('classic')}>Clasic</button>
        <button type="button" disabled={!modernAvailable} className={`position-button ${logoStyle === 'modern' ? 'selected' : ''}`} onClick={() => onLogoStyleChange('modern')}>Modern</button>
      </div>
      <span className="field-note">
        {modernAvailable
          ? 'Modern: logo-uri mai mari, pe panouri semi-transparente.'
          : 'Stilul Modern se activează doar când toate logo-urile sunt PNG cu fundal transparent.'}
      </span>
    </section>
  );
}